var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("validation-provider", {
    ref: "fieldValidationRef",
    attrs: { rules: _vm.rules },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function ({ errors, reset }) {
            return [
              _c(
                "v-select",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        "error-messages": errors,
                        value: _vm.value,
                        outlined: "",
                        dense: "",
                        "item-color": "primary",
                        "append-icon": "mdi-chevron-down",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$emit(
                            "update:value",
                            !!$event ? $event : null
                          )
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          !!_vm.$attrs.label
                            ? {
                                key: "label",
                                fn: function () {
                                  return [
                                    _vm.rules.includes("required")
                                      ? _c(
                                          "span",
                                          { staticClass: "error--text" },
                                          [_vm._v("*")]
                                        )
                                      : _vm._e(),
                                    _vm._v(
                                      " " + _vm._s(_vm.$attrs.label) + " "
                                    ),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                          _vm._l(_vm.$scopedSlots, function (_, slot) {
                            return {
                              key: slot,
                              fn: function (scope) {
                                return [_vm._t(slot, null, null, scope)]
                              },
                            }
                          }),
                        ],
                        null,
                        true
                      ),
                    },
                    "v-select",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                ),
                [
                  _vm._l(Object.keys(_vm.$slots), function (slot) {
                    return _vm._t(slot, null, { slot: slot, reset: reset })
                  }),
                ],
                2
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }